var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{key:_vm.height,ref:"payerComponent",staticClass:"item",staticStyle:{"min-height":"200px"},style:({ 'height': _vm.height}),attrs:{"id":"player"}})])}
var staticRenderFns = []

export { render, staticRenderFns }